export const knearState = {
    startBlock: {
        title: 'Knear',
        subtitle: 'Your favorite music event app',
        image: '/knear-images/start-image.png',
        text: [
            `Knear is an application which allows looking for music events in your location and creating new ones of your own. Also, a user can add his songs from his iTunes account. Thus, this music event app solves the problem of finding and visiting concerts, performances of singers, and other similar occasions nearby. And if you're an artist, it's your great chance to draw attention to your personal musical activity.`
        ]
    },
    projectInfoBlock: {
        title: 'Project info',
        points: [
            {
                title: 'Project:',
                subtitle: 'Event app development'
            },
            {
                title: 'Product:',
                subtitle: 'iOS'
            },
            {
                title: 'Category:',
                subtitle: 'Events Services'
            },
            {
                title: 'Project timeline:',
                subtitle: '4 months'
            }
        ]
    },
    accordion: {
        title: 'Development Challenges to Overcome',
        items: [
            {
                id: 1,
                title: 'Event relevance and synchronization',
                text: [
                    'To create a music app which performs its functions at the proper level, we needed to ensure that the states of events in time were up-to-date and synchronized.',
                    'We built asynchronous tasks which were automatically assigned to the specified time and started or terminated the event. In addition, we wrote an algorithm aimed to check the validity of states every 15 minutes.',
                    `To completely avoid unpleasant surprises, there are also another validations running. Their goal is to check whether it is possible to place a created or modified event at the specified time - it shouldn't overlap in time with others.`
                ]
            },
            {
                id: 2,
                title: 'Music service API',
                text: [
                    'This new music app provides the possibility to supplement a personal profile with the user’s own songs. It took awhile, but we figured out how to implement this process as efficiently as possible.',
                    'We conducted the in-depth research on popular music services and their APIs (Spotify, iTunes, SoundCloud, etc.). As a result, our specialists came to the conclusion that iTunes would be the best solution.',
                    `Now, users of the music event app named Knear have the opportunity to add their songs from the iTunes accounts.`
                ]
            },
            {
                id: 3,
                title: 'Unique UI/UX',
                text: [
                    'The issue of how to make a music app includes several stages, and in addition to coding, it assumes designing the application interface. We are proud to report that our team has created a complete design from scratch, from UX wireframes to UI.',
                    'We made our best to build a user-friendly intuitive interface and save users from having to perform extra actions. And we managed to create a music app whose design became an innovative solution for displaying maps, pop-ups, menus, and animated transitions between screens.'
                ]
            },
            {
                id: 4,
                title: 'MapBox API integration',
                text: [
                    'Since the music event app has a unique design, our experts should have chosen a map that would be suitable for both technical and visual parameters. After a long search for the best solution, we selected the one perfectly embodying our idea - the MapBox API technology.',
                ]
            },
        ]
    },
    benefitsArtist: {
        title: 'Benefits for artists and music fans',
        text: [
            'Thinking of how to make a music app, we tried to find a way to please not only artists but also their fans. And now we can say Knear is a new music app which meets the needs of both groups of users.'
        ]
    },
    benefitsSeller: {
        title: 'Benefits for music fans',
        points: [
            'Searching for artists or music shows playing in the user location.',
            'The possibility to get more information about the artist (if he has posted information about himself in the database of the music event app).',
            'The "Applause" feature which allows the user to express his appreciation.',
        ]
    },
    benefitsBuyer: {
        title: 'Benefits for the buyer',
        points: [
            'A personal artist profile (all user’s songs from iTunes will be listed here).',
            'The chance to announce any of user’s upcoming performances, indicating exactly where they will take place.',
            'The "Live now" feature allowing to organize impromptu shows anywhere a user is right now.',
        ]
    },
    storyBegins: {
        title: 'How the Story Begins',
        text: [
            'Initially, the client came up with the idea of a new music app of the original format. We started the application development from scratch: all we had was a brief description of the project and hand-drawn rough sketches. Despite the challenges we had met, our team managed to create a music app of high quality and with advanced functionality.',
            'In the first version, the music event app is only available on iOS devices in App Store of the USA. However, it’s just the beginning, and the project will gradually be extended and improved.'
        ]
    },
    previewBlocks: [
        {
            id: 1,
            title: `Finding music events nearby`,
            subtitle: `This feature of Knear allows the user to keep track of all musical events in his location. He can see where the concert will soon take place or who of the artists decided to arrange an impromptu show right now.`,
            image: '/knear-images/mockup.png',
            points: []
        },
        {
            id: 2,
            title: `Event details`,
            subtitle: `Of course, the application also provides an opportunity to learn all the details of the event that interested you. And on the same screen, the user can express his approval by using the applause features.`,
            image: '/knear-images/mockup-2.png',
            points: []
        },
        {
            id: 3,
            title: `Creating events`,
            subtitle: 'This feature is intended for artists who want to place their musical occasion on the map of the music event app:',
            image: '/knear-images/mockup-3.png',
            points: [
                'Event type.',
                'Its locations.',
                'Exact date and time.',
            ],
        },
    ]
}

export interface AccordionItemInterface {
    id: number;
    title: string;
    text: Array<string>
}

export interface ProjectInfoPoint {
    title: string;
    subtitle: string;
}

export interface PreviewBlockPoint {
    id: number;
    title: string;
    subtitle: string;
    image: string;
    points: Array<string>;
}
